/**
 * CacheScope enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file CacheScope.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum CacheScope {
  OVERRIDE = 'override',
  GLOBAL = 'global',
  MODULE = 'module',
  PROJECT = 'project',
}